/**
 * ProGym Luxury Editorial - Theme JS
 * GSAP Powered Animations - Award Winning UI/UX
 */

document.addEventListener('DOMContentLoaded', () => {
  console.log('ProGym Luxury Editorial Theme Initialized');
  
  // Register GSAP Plugins
  gsap.registerPlugin(ScrollTrigger);

  // Initialize Global Animations
  initScrollAnimations();
  initTextAnimations();
  initParallax();
  initLuxuryInteractions();
});

const initScrollAnimations = () => {
  // Reveal animations for general elements
  const reveals = document.querySelectorAll('.gsap-reveal');
  
  reveals.forEach((el) => {
    gsap.from(el, {
      scrollTrigger: {
        trigger: el,
        start: 'top 90%',
        toggleActions: 'play none none reverse'
      },
      y: 40,
      opacity: 0,
      duration: 1,
      ease: 'expo.out'
    });
  });
};

const initTextAnimations = () => {
  // Sophisticated text reveal using lines
  const textReveals = document.querySelectorAll('.gsap-reveal-text');
  
  textReveals.forEach((el) => {
    // Note: We use a simplified version here as SplitText is a paid plugin. 
    // We simulate it using CSS overflow hidden and inner spans or just clean fade-ups.
    gsap.from(el, {
      scrollTrigger: {
        trigger: el,
        start: 'top 85%'
      },
      y: '100%',
      opacity: 0,
      duration: 1.5,
      ease: 'expo.out',
      delay: 0.2
    });
  });
};

const initParallax = () => {
  // Subtle parallax for luxury hero images
  const heroes = document.querySelectorAll('.luxury-hero__image');
  
  heroes.forEach((img) => {
    gsap.to(img, {
      scrollTrigger: {
        trigger: img,
        start: 'top top',
        end: 'bottom top',
        scrub: true
      },
      y: '20%',
      ease: 'none'
    });
  });
};

const initLuxuryInteractions = () => {
  // Magnetic button effect (Subtle)
  const buttons = document.querySelectorAll('.btn--primary');
  
  buttons.forEach((btn) => {
    btn.addEventListener('mousemove', (e) => {
      const rect = btn.getBoundingClientRect();
      const x = e.clientX - rect.left - rect.width / 2;
      const y = e.clientY - rect.top - rect.height / 2;
      
      gsap.to(btn, {
        x: x * 0.2,
        y: y * 0.2,
        duration: 0.3,
        ease: 'power2.out'
      });
    });
    
    btn.addEventListener('mouseleave', () => {
      gsap.to(btn, {
        x: 0,
        y: 0,
        duration: 0.5,
        ease: 'elastic.out(1, 0.3)'
      });
    });
  });
};
